import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import ButtonC from '../components/ButtonC'
import { useNavigate, useLocation } from 'react-router-dom';


const waitForElm = (selector) => {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(mutations => {
      if (document.querySelector(selector)) {
        observer.disconnect();
        resolve(document.querySelector(selector));
      }
    });

    // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

const navArr = [
  {
    title: "Case Studies",
    link: "/case_studies",
    eventName: "navbar_case_studies_button",
    isRoute: true,
  },
  {
    title: "About Us",
    link: "/about_us",
    eventName: "navbar_about_us_button",
    isRoute: true,
  },
  {
    title:"Latest News",
    link:"/latest_news",
    eventName:"navbar_latest_news_button",
    isRoute: true,
  }
]

function NavbarM(props) {
  const [isClicked, setIsClicked] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === '/';
  const handleButtonClick = () => {
    setIsClicked(!isClicked);
    document.body.classList.toggle('bodyFixed');
  };

  const scrollToSection = (secLink) => {
    waitForElm(secLink).then((section) => {
      if (section) {
        let offset = 145;
        if (window.innerWidth < 1560) offset = 90;
        if (window.innerWidth < 1370) offset = 75;
        if (window.innerWidth < 800) offset = 85;
        if (window.innerWidth < 568) offset = 70;
        const sectionPosition = section.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: sectionPosition, behavior: 'smooth' });
      }
      setIsClicked(false);
      if (window.innerWidth < 800) {
        document.querySelector('.menuToggle')?.click();
      }
    });
  };

  const handleNavLinkClick = (e, secLink, eventName) => {
    if (!!e) e.preventDefault();

    if (!isHome) {
      navigate('/');
      setTimeout(() => scrollToSection(secLink), 400);
    } else {
      scrollToSection(secLink);
    }
  };

  const navBrand = () => {
    if (!isHome) {
      navigate('/');
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if (window.innerWidth < 800) {
      if (!isClicked) return;
      document.querySelector('.menuToggle')?.click();
    }
  };

  return (
    <Navbar expand="lg" className={`${isClicked ? 'navBar__' : ''}`}>
      <Container>
        <Navbar.Brand style={{display:"block"}} href="/" className='me-0 p-0' onClick={(e) => { e.preventDefault(); navBrand(); }}><img src={props.logo} alt="" /></Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" className='menuToggle' onClick={handleButtonClick} />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mx-auto">
            {
              navArr.map((navData) => (
                navData.isRoute
                  ? <Nav.Link key={navData.eventName} href={navData.link} onClick={(e) => { e.preventDefault(); navigate(navData.link); setIsClicked(false); }}>{navData.title}</Nav.Link>
                  : <Nav.Link key={navData.eventName} href={navData.link} onClick={(e) => handleNavLinkClick(e, navData.link, navData.eventName)}>{navData.title}</Nav.Link>
              ))
            }
            <a className="navContactLink" href="#contactUS" onClick={ (e) => handleNavLinkClick(e, "#contactUS", "navbar_contact_us_button")}><ButtonC btnTxt="Contact Us" btnBgClr="#78F2A2" btnClr="#000" btnHeight="40px" className="navBtn" /></a>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavbarM;